import { showErrorMessage as showErrorMessageAntd } from 'src/shared/utils/messages';

export class NotificationsStore {
  showNotificationMessage: (value: string) => void;

  constructor() {
    this.showNotificationMessage = showErrorMessageAntd;
  }
}
